import React from "react";

const JobInfoItem = ({ icon, label, value }) => {
  return (
    <li>
      <i className={icon}></i> {label} :{" "}
      {value?.trim() !== "" ? value : "Not disclosed"}
    </li>
  );
};

export default JobInfoItem;
